import React, { useState, useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router'
import LanguageSwitcher from 'components/LanguageSwitcher'

import i18n from 'i18n'
import { useTranslation } from 'react-i18next'
// import officeNext from '@/assets/images/logo/officeNext.svg'
import { useIsMobile, calculateRemainingDays } from 'utils'
import { ADMIN_CONSOLE_HOME } from 'config/feature-flags'

import { Button } from 'antd'
import { GlobalOutlined } from '@ant-design/icons'
import { getTempEnvParam } from 'env'

import getAdminMenuList from 'apptype-config/admin/menu'
import { SERVICE_LOGO_IMAGE } from 'service'

import PLAN_TYPE from 'types/utils'
import UserMenu from './UserMenu'
import { openUpgradeRequestConfirm } from './UpgradeRequestModal'
import { canShowUpgradeButton } from './UpgradeRequestModal/helper'
import styles from './style.module.scss'

const mapStateToProps = ({ settings, user }) => ({
  logo: settings.logo,
  authorized: user.authorized,
  workspace: user.workspace,
  settings,
})

export const getBasePath = (value) => {
  if (!value) return ''
  const idx = value.indexOf('?')
  return idx !== -1 ? value.substring(0, idx) : value
}

const TopBar = (props) => {
  const { authorized, mode, workspace } = props
  const settings = useSelector((state) => state.settings)
  const user = useSelector((state) => state.user)
  const { paidLicense } = user || {}

  console.log('settings', settings)
  const { t } = useTranslation()

  const menuList =
    workspace && workspace.role === 'admin'
      ? [...getAdminMenuList().adminMenuList, ...getAdminMenuList().menuList]
      : getAdminMenuList().menuList

  const text = menuList.find(
    (menu) => getBasePath(menu.url) === getBasePath(window.location.pathname),
  )?.title

  const [menuText, setMenuText] = useState(text)
  const pathName = useLocation().pathname
  const isMobile = useIsMobile()

  useEffect(() => {
    const recordPageTitle = getTempEnvParam('pageTitle')
    setMenuText(recordPageTitle || text)
  }, [pathName, settings?.locale])

  const displayText = () => {
    if (isMobile) {
      return menuText || ''
    }
    if (pathName.startsWith('/admin')) {
      return i18n.t('menu.adminConsole')
    }

    return ''
  }

  const rightComp =
    authorized === true && mode !== 'public' ? (
      <React.Fragment>
        <div className="">
          <React.Suspense fallback={<div>Loading...</div>}>
            <UserMenu />
          </React.Suspense>
        </div>
      </React.Fragment>
    ) : (
      <div className="me-4 d-none d-sm-block">
        <div className="menu-language">
          <GlobalOutlined className="me-2" />
          <span className="label">{t('topBar.profileMenu.language')} : </span>
          <LanguageSwitcher />
        </div>
      </div>
    )

  return (
    <div className={styles.topbar}>
      <div className={styles.wrapper}>
        <div className={styles.logoContainer}>
          <div className={styles.logo}>
            <Link to={pathName.startsWith('/admin') ? ADMIN_CONSOLE_HOME : '/'}>
              <img src={SERVICE_LOGO_IMAGE} alt="Safebox" />
              {displayText().length > 0 && <span className={styles.menuText}>{displayText()}</span>}
            </Link>
            {paidLicense?.plan_type === PLAN_TYPE.TRIAL &&
              (() => {
                const remainingDays = calculateRemainingDays(paidLicense?.expires_at)
                return (
                  <span className={styles.trialPeriod}>
                    {remainingDays === 0
                      ? t('topBar.trialPeriodToday')
                      : t('topBar.trialPeriod', { left: remainingDays })}
                  </span>
                )
              })()}
            {canShowUpgradeButton({ paidLicense, workspace }) && (
              <Button
                size="small"
                className={styles.upgradeButton}
                onClick={() =>
                  openUpgradeRequestConfirm({ workspaceName: workspace?.workspace_name })
                }
              >
                {t('topBar.upgradeButton')}
              </Button>
            )}
          </div>
        </div>
        {rightComp}
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(TopBar)
